{
  "randevu": {
    "Randevular": "Appointments",
    "Randevu Ekle": "Add Appointment",
    "Randevu": "Appointment",
    "Müşteri": "Customer",
    "Tarih": "Date",
    "Başlama Saat": "Start Time",
    "Bitiş Saat": "End Time",
    "Görüşme": "Meeting",
    "Not": "Note",
    "Ulaşım": "Transportation",
    "Görüşmeye Katılanlar": "Meeting Participants",
    "Görüşme Sonuç": "Meeting Result",
    "Tekrar Tarih": "Repeat Date",
    "Tekrar Başlama Saat": "Repeat Start Time",
    "Tekrar Bitiş Saat": "Repeat End Time",
    "Randevu Bilgi": "Appointment Info",
    "Onay Bekliyor": "Pending Approval",
    "Saat Kontrol": "Time Check"
  }
}
